import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import DefaultRoutes from './default'
import CustomstRoutes from './customs'


const routeMap = new Map();

// Ajouter d'abord les DefaultRoutes
for (const route of DefaultRoutes) {
  routeMap.set(route.name, route);
}

// Ajouter ensuite les CustomstRoutes (écrase les doublons)
for (const route of CustomstRoutes) {
  routeMap.set(route.name, route); // écrase si `path` déjà présent
}

// Résultat final sans doublons, avec priorité aux CustomstRoutes
const routes = Array.from(routeMap.values());




Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes:routes,
    base: process.env.BASE_URL,
    scrollBehavior() {
        return {x: 0, y: 0}
    },

})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = 'none'
    }
})

router.beforeEach((to, from, next) => {
    console.log('Voici les paramètres de la route ==> ', to, from);

    if (to.matched.some(record => record.meta.requiresAuth)) {
        // Récupérer les informations nécessaires depuis le store
        const user = store.state.app.user; // Utilisation directe du store
        const token = user?.token;
        const permissions = user?.permissions;
        console.log('User dans le store :', store.state.app.user);
        // Vérification des conditions d'authentification et permissions
        if (!user || !token || !permissions || permissions.length === 0) {
            console.warn('Utilisateur non authentifié ou permissions manquantes');

            // Rediriger vers la page de connexion
            next({
                path: '/login',
                query: { redirect: to.fullPath } // Sauvegarder la route d'origine
            });
        } else {
            console.log('Utilisateur authentifié, permissions valides');
            next(); // Autoriser l'accès à la route demandée
        }
    } else {
        // Si la route ne nécessite pas d'authentification, continuer la navigation
        next();
    }
});
export default router
